const api = {
	//url:'/jgapi',	
	
	url:'http://m.cc678.cn/jgapi/',
	urls:'http://m.cc678.cn',
	urlz:'m.cc678.cn',
	urlj:'http://m.cc678.cn/sack/jgapi/',
	/*url:'http://wcq.ivo.cn/jgapi/',
	urls:'http://wcq.ivo.cn',
	urlz:'wcq.ivo.cn',*/
	
}
const userid = '';
const openid = '';
const phone = '';
const footerArr=[
	{
		"title": "真题",
		"url": "/v_testPaper",
		"img1": require('../img/icon2_11.png'),
		"img2": require('../img/icon2_22.png'),
	}
	,
	{
		"title": "任务",
		"url": "/index",
		"img1": require('../img/client_zy_1.png'),
		"img2": require('../img/client_zy_2.png'),
	}
	,
	{
		"title": "知识点",
		"url": "/knowledge",
		"img1": require('../img/knowledge_1.png'),
		"img2": require('../img/knowledge_2.png'),
	},	
	{
		"title": "收藏",
		"url": "/follow",
		"img1": require('../img/collection_1.png'),
		"img2": require('../img/collection_2.png'),
	},
	{
		"title": "我的",
		"url": "/my_information",
		"img1": require('../img/icon3_1.png'),
		"img2": require('../img/icon3_2.png'),
	}, 				    		
];

export default {
	api,
	userid,
	openid,
	phone,
	footerArr,
	setUserid(val){
		this.userid = val;
	},
	setOpenid(val){
		this.openid = val;
	},
	setPhone(val){
		this.phone = val;
	},
	setPhone(val){
		this.footerArr = val;
	},
	setPhone(val){
		this.api = val;
	},	
}


// WEBPACK FOOTER //
// ./src/http/api.js